import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { setAccountInfo } from "Store/appStore/action";
import platform from "Pub/js/platform";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import { getStore, setStore } from "Pub/js/storageUtils";
import Notice from "Components/Notice";
import "./MTZBDate.less";
let { base, formatDatetime } = platform;
const NCTZDatePickClientHourTime = base.NCTZDatePickClientHourTime;
const { NCTooltip } = base;
const FORMAT = "YYYY-MM-DD HH:mm:ss";
import BusinessInfoController from "../APPDataStore/BusinessInfoController";
const dateInputPlaceholder = langCheck("0000PUB-000114"); /* 国际化处理： 选择日期*/
const { LocalToDongbaTime, DongbaToLocalTime } = platform;

class MTZBDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            value: moment().format(FORMAT),
        };
        //本文件sonar扫描箭头函数不能解析，为了让sonar扫描通过，只能这么写
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleToday = this.handleToday.bind(this);
        this.handleBusinessOpen = this.handleBusinessOpen.bind(this);
        this.handleBusinessClose = this.handleBusinessClose.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleHotKey = this.handleHotKey.bind(this);
    }
    handleChange(date) {
        this.setState({
            value: date,
            isOpen: true,
        });
    }
    //目的是双击日期时不关闭日历框
    handleSelect() {
        if (!this.canClose) {
            this.setState({ isOpen: true });
        } else {
            this.canClose = false;
        }
    }
    /**
     * 取消日期
     */
    handleCancel() {
        this.canClose = true;
        this.setState({
            isOpen: false,
            value: this.props.businessDate,
        });
    }
    /**
     * 确定事件
     */
    handleOk() {
        this.handleDateChange();
    }
    /**
     * 今天事件
     */
    handleToday() {
        const Today = this.getToday();
        this.setState({ value: Today }, () => {
            this.handleDateChange(Today);
        });
    }
    /**
     * 业务日期打开
     */
    handleBusinessOpen() {
        const { editBizdateEnable } = this.props;
        if (!editBizdateEnable) {
            // false 不可修改
            // Notice({
            //     status: "warning",
            //     msg: '不可修改业务日期' //'不可修改业务日期'
            // });
            return;
        }
        this.setState({ isOpen: true }, () => {
            document.querySelector('.nc-workbench-businessdate-dropdown input').focus();
        });
    }
    /**
     * 业务日期关闭
     */
    handleBusinessClose() {
        if (this.props.businessDate) {
            this.setState({
                value: this.props.businessDate,
                isOpen: false,
            });
        }
    }
    /**
     * 业务日期切换
     */
    handleDateChange(value) {
        this.blurByHandleOk = true; // 选择业务日期确定之后触发的blur
        this.inputBlur();
        setTimeout(() => {
            const newDate = value || this.state.value;
            const isToday = this.validateIsToday(newDate); //判断是否今天
            if (newDate) {
                Ajax({
                    url: `/nccloud/platform/appregister/setbizdate.do`,
                    info: {
                        name: langCheck("0000PUB-000115") /* 国际化处理： 业务日期*/,
                        appcode: "10228888",
                        action: langCheck("0000PUB-000116"), /* 国际化处理： 更改业务日期*/
                    },
                    data: {
                        bizDateTime: newDate,
                        isToday,
                    },
                    loading: true,
                    success: ({ data: { data } }) => {
                        if (data) {
                            this.canClose = true; // 解决日期组件不能关闭的问题（基础组件多调用了select注册的方法）
                            this.setState({ isOpen: false });
                            let infoData = getStore("STOREFORINFODATA", true);
                            // 对比日期
                            const businessDateChanged = infoData.originalBizDateTime.split(' ').shift() !== newDate.split(' ').shift();
                            infoData.bizDateTime = newDate;
                            infoData.businessDateChanged = businessDateChanged;
                            setStore("STOREFORINFODATA", infoData, true);
                            let info = window.GETBUSINESSINFO();
                            info.businessDate = newDate;
                            info.businessDateChanged = businessDateChanged;
                            BusinessInfoController(() => {})(info);
                            this.props.setAccountInfo({ businessDate: newDate });
                        }
                    },
                });
            } else {
                this.setState({
                    isOpen: false,
                    value: this.props.businessDate,
                });
            }
        }, 100);

    }
    //监听键盘按键事件（为自动化测试添加）
    handleHotKey(event) {
        let e = event || window.event || arguments.callee.caller.arguments[0];
        if (this.state.isOpen) {
            switch (e && e.keyCode) {
                case 13: //按Enter确定选中日期
                    this.handleOk();
                    break;
                case 27: //按ESC关闭业务日期
                    this.inputBlur();
                    this.handleCancel();
                    break;
                default:
                    break;
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.businessDate !== this.state.value) {
            this.setState({ value: nextProps.businessDate });
        }
    }
    componentDidMount() {
        const { businessDate } = this.props;
        if (businessDate !== this.state.value) {
            this.setState({ value: businessDate });
        }
        document.addEventListener("keydown", this.handleHotKey);
        this.closeCalendar('addEventListener');
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            clearTimeout(this.blurTimer);
        }
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleHotKey);
        this.closeCalendar('removeEventListener');
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }

    inputBlur = () => {
        document.querySelector('.nc-workbench-businessdate-dropdown input').blur();
    }
    //判断是否今天
    validateIsToday = date => {
        return moment(date).isSame(this.getToday(), 'day');
    };

    getToday = () => {
        return LocalToDongbaTime(moment()).format(FORMAT);
    }

    // 日期输入框失去焦点时关闭日历
    closeCalendar = type => {
        // const input = document.querySelector('.nc-workbench-nav .single-input');
        // if (input) {
        //     input[type]('blur', this.handleBlur);
        // }
    }
    handleBlur = () => {
        if (!this.state.isOpen) {return;}
        /*
            这里为啥有个150毫秒的延迟，是因为点击确定时handleDateChange先执行了blur
            但是那边有个100毫秒的延迟，如果这里执行早于那边，那么value直接被复原，那边就出问题了
        */
        this.blurTimer = setTimeout(() => {
            const resultState = { isOpen: false };
            if (this.blurByHandleOk) { // 选择业务日期确定之后触发的blur，这里不用恢复value,不然会造成一个闪动效果（恢复之后在接口请求成功会变成最新值）
                this.blurByHandleOk = false;
            } else {
                resultState.value = this.props.businessDate;
            }
            this.setState(resultState);
        }, 150);
    }

    render() {
        const { editBizdateEnable } = this.props;
        let { isOpen, value } = this.state;
        let flag = this.validateIsToday(value);
        let busunessTitle = flag
            ? langCheck("0000PUB-000115")
            : langCheck("0000PUB-000117"); /* 国际化处理： 业务日期,该业务日期不是今日日期!*/
        const ExtraFooter = (
            <div className='workbench-ExtraFooter'>
                <div className='left'>
                    <span className='btn' onClick={this.handleToday}>
                        {langCheck("0000PUB-000118")}
                        {/* 国际化处理： 今天*/}
                    </span>
                </div>
                <div className='right'>
                    <span className='btn' onClick={this.handleOk}>
                        {langCheck("0000PUB-000108")}
                        {/* 国际化处理： 确定*/}
                    </span>
                    <span className='btn margin-left-15' onClick={this.handleCancel}>
                        {langCheck("0000PUB-000119")}
                        {/* 国际化处理： 取消*/}
                    </span>
                </div>
            </div>
        );
        return (
            <div
                ref={ref => this.businessDateRef = ref}
                fieldid='business-date' //自动化测试用标记
                className={`nc-workbench-businessdate ${flag ? "" : "unbusinessdate"}`}
            >
                <NCTZDatePickClientHourTime
                    getPopupContainer={() => this.businessDateRef}
                    className='nc-workbench-businessdate-dropdown'
                    style={isOpen ? { zIndex: 400 } : {}} //给自动化测试用
                    dropdownClassName='fieldid_business-date_calendar'
                    // format='YYYY-MM-DD' //业务日期不显示时分秒
                    open={isOpen}
                    onChange={this.handleChange}
                    onSelect={this.handleSelect}
                    value={value}
                    placeholder={dateInputPlaceholder}
                    showToday={false}
                    showOk={false}
                    showTime={false}
                    renderFooter={() => ExtraFooter}
                    autofocus={true}
                    showClear={false}
                    renderIcon={() => <i className='iconfont icon-riqibip' />}
                />
                {!flag ? <span className='business-date-flag'>!</span> : ""}
                <NCTooltip
                    placement="bottom"
                    trigger="hover"
                    overlay={busunessTitle}
                    delayShow={500}
                    delay={1}
                    mouseLeaveDelay={0}
                >
                    <div
                        className='business-date-block'
                        onClick={this.handleBusinessOpen}
                        style={editBizdateEnable ? {} : { cursor: 'default' }}
                    >
                        { formatDatetime(value, 'date') }
                    </div>
                </NCTooltip>
                {isOpen ? <div className='business-date-mask' onClick={this.handleBusinessClose} /> : null}
            </div>
        );
    }
}
MTZBDate.propsTypes = {
    businessDate: PropTypes.string.isRequired,
    editBizdateEnable: PropTypes.bool.isRequired,
};

export default connect(
    ({ appData }) => ({
        businessDate: appData.businessDate,
        editBizdateEnable: appData.editBizdateEnable,
    }),
    { setAccountInfo },
)(MTZBDate);
